import React, { useState, useCallback } from 'react';
import { ProjectList } from '../components/projects/ProjectList';
import { CreateProjectModal } from '../components/projects/CreateProjectModal';

interface DashboardPageProps {
  onNavigateToProject: (projectId: string) => void;
}

export const DashboardPage: React.FC<DashboardPageProps> = ({ onNavigateToProject }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  return (
    <>
      <ProjectList
        key={refreshKey}
        onSelectProject={onNavigateToProject}
        onCreateProject={() => setShowCreateModal(true)}
      />
      <CreateProjectModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onCreated={handleCreated}
      />
    </>
  );
};
